// cSpell:disable
import { ref } from 'vue'
import config from '../config/config'

export default {
  install(app, { interval = 60000 } = {}) {
    
    const currentVersion = config.appVersion
    const hasNewVersion = ref(null)

    async function checkVersion() {
      try {
        const res = await fetch(`${config.apiSchema}://${config.apiHost}:${config.apiPort}/${config.apiPath}version.json`, { cache: 'no-cache' })
        const { version } = await res.json()

        if (version && version !== currentVersion) {
          console.warn('Nalezena nová verze aplikace:', version)
          hasNewVersion.value = version
        }
      } catch (err) {
        console.error('Kontrola verze selhala:', err)
      }
    }

    // Spustí kontrolu hned po načtení
    checkVersion()
    // Nastaví opakovanou kontrolu
    setInterval(checkVersion, interval)
    console.log(`Plugin: Checker verze aktivován s intervalem ${interval / 1000}s`)

    app.provide('hasNewVersion', hasNewVersion)
    
  }
}
